export default {
    en: {
        title: 'Settings',
        chooseTheme: 'Choose Theme',
        defaultTheme: 'Default Theme',
        dark: 'Dark Theme',
        payments: 'Price Of products',
        quality: 'Quality',
        quantity: 'Quantity',
        square: 'Total',
        saleValue: 'Total sale value',
        importValue: 'Total import value',
        importPrice: 'Factory price',
        salePrice: 'Sale Price',
        more: 'Actions',
        save: 'Save'
    },
    uz: {
        title: 'Sozlamalar',
        chooseTheme: "Ranglar to'plamini tanlang",
        defaultTheme: "Och ranglar",
        dark: "To'q ranglar",
        payments: "Mahsulot narxlari",
        quality: 'Sifat',
        quantity: 'Soni',
        square: 'Jami',
        saleValue: 'Umumiy olish qiymati',
        importValue: 'Umumiy sotish narxi',
        importPrice: "Mahsulot narxi",
        salePrice: 'Sotish narxi',
        more: 'Actions',
        save: 'Saqlash'
    },
    ru: {
        title: 'Настройки',
        chooseTheme: 'Выберите тему',
        defaultTheme: 'Тема по умолчанию',
        dark: 'Dark Theme',
        payments: 'Цена продуктов',
        quality: 'Качество',
        quantity: 'Количество',
        square: 'Всего',
        saleValue: 'Общая стоимость',
        importValue: 'Общая стоимость',
        importPrice: 'Общая цена импорта',
        salePrice: 'Общая цена продажи',
        more: 'Действия',
        save: 'Сохранить'
    }
}